<script>
  import {
    Breakpoint,
    OverflowMenu,
    OverflowMenuItem,
  } from "carbon-components-svelte";

  //// imports
  import FlowPlotterSmall from "lib/components/FlowPlotterSmall.svelte";
  import download from "downloadjs";
  import { Loading } from "carbon-components-svelte";
  import { fetchWithSession } from "lib/util/fetchWithSession.js";
  import { pmfilters } from "lib/stores.js";
  import { filtersConfigStore } from "@stores/filtersConfigStores.js";
  import { getApplicableFilters } from "../../../../lib/util/getApplicableFilters";

  import Filter from "./components/filter/Filter.svelte";

  import { formatTimeDelta } from "lib/util/formatfunctions.js";

  // ui-elements
  import ContentSwitcher from "lib/components/ContentSwitcher.svelte";
  import ButtonPlusMinus from "lib/components/buttonPlusMinus.svelte";

  // sidenav

  import { Accordion, SectionWrapper, Button } from "paxray-components-svelte";
  import AppSelection from "./components/appSelection.svelte";
  import AppInformation from "./components/appInformation.svelte";
  import Header from "lib/components/Header.svelte";

  import MatrixTable from "./components/MatrixTable.svelte";
  import FilterToast from "./components/FilterToast.svelte";
  import {
    APPLICATIONS_ICON,
    APPOVERVIEW_ICON,
    WINDOWS_ICON,
    INTERACTIONS_ICON,
    TIME_BEFORE_ICON,
    TIME_AFTER_ICON,
    SQUARE_LANDSCAPE_ICON,
    FULLSCREEN_ICON,
    FULLSCREEN_OFF_ICON,
    ARROW_LEFT_ICON,
  } from "@utils/icons.js";

  export let analysisid;
  const { setCurrentView } = filtersConfigStore;

  let currentApp = "";
  let currentAppInformation = currentApp;
  let windowPartitionsLoading = false;

  let zoomLevel = 100;
  let applicationlist = [];
  let windowlist = [];
  let loading = true;
  let loadingApp = true;
  let selectedKPIindex = 0;
  let screenSize;

  let from;
  let to;
  let dataNew;
  let fullscreen = false;

  let disabledlevels = [3];
  let selectedLevel = 0;

  let napps = 5;
  let levelBefore = 1;
  let levelAfter = 1;

  let appGraphLoading = true;

  let disableModes = [2];
  let selectMode = 0;
  let firstLoad = true;
  let requestTimeout;
  let buttonsDisabled = false;
  let view = "App Flow";

  let graph = { nodes: [], edges: [] };

  let showToast = false;

  let flowPlotterRef;

  $: setCurrentView(view);

  $: selectMode === 0 ? getWindowPartitions() : loadAppMatrix();

  $: currentAppInformation = !isNaN(currentApp)
    ? currentApp
    : currentApp.split("###")[0];

  $: currentApp = isNaN(currentApp) ? currentApp.split("###")[0] : currentApp;

  $: {
    if (
      selectedKPIindex == 0 &&
      currentApp &&
      $pmfilters &&
      selectedLevel >= 0 &&
      (levelAfter || levelBefore) &&
      $filtersConfigStore.storeLoaded
    ) {
      if (firstLoad) {
        firstLoad = false;
        loadAppGraph(currentApp);
      } else
        delayedRequest(() => {
          loadAppGraph(currentApp);
          getWindowPartitions();
        });
    } else if (selectedKPIindex)
      loadAppGraphTime(
        currentApp,
        napps,
        selectedKPIindex == 1 ? "before" : "after",
      );
  }

  function handleDownload() {
    if (flowPlotterRef?.downloadSVG) {
      flowPlotterRef.downloadSVG(currentApp);
    }
  }

  function delayedRequest(callback) {
    if (requestTimeout) {
      clearTimeout(requestTimeout);
    }
    requestTimeout = setTimeout(() => {
      buttonsDisabled = true;
      callback();
    }, 500);
  }

  function transformGraph(graph, levelBefore, levelAfter) {
    let transformedEdges = [];
    let connectedNodes = new Set();

    for (let i = 1; i <= levelBefore; i++) {
      let key = `Edges_${i}b`;
      if (graph.edges[key]) {
        transformedEdges.push(...graph.edges[key]);
      }
    }

    for (let i = 1; i <= levelAfter; i++) {
      let key = `Edges_${i}a`;
      if (graph.edges[key]) {
        transformedEdges.push(...graph.edges[key]);
      }
    }

    transformedEdges.forEach((edge) => {
      connectedNodes.add(edge.from);
      connectedNodes.add(edge.to);
    });

    let filteredNodes = graph.nodes.filter((node) =>
      connectedNodes.has(node.id),
    );

    return {
      nodes: filteredNodes,
      edges: transformedEdges,
    };
  }

  function getDataTable(data) {
    dataNew = [];
    from = [];
    to = ["From/to"];
    data.forEach((dataT) => {
      from.push(dataT.from);
      dataT.to.forEach((dest) => {
        if (!to.includes(dest.to)) {
          to.push(dest.to);
        }
      });
    });

    data.forEach((e) => {
      let row = [e.from];
      let number;

      for (let i = 1; i < to.length; i++) {
        number = "";
        e.to.forEach((dest) => {
          if (dest.to == to[i]) {
            number = dest.count;
          }
        });
        row.push(number);
      }
      dataNew.push(row);
    });
  }

  function getWindowPartitions() {
    windowPartitionsLoading = true;
    loadingApp = true;
    loading = true;
    const applicableFilters = getApplicableFilters($pmfilters[analysisid]);
    const filterString = JSON.stringify(applicableFilters);
    fetchWithSession(
      `/api/analysis/getWindowPartitions?analysisid=${analysisid}&filter=${filterString}`,
    )
      .then((res) => res.json())
      .then((data) => {
        windowlist = data;
        windowPartitionsLoading = false;
        loading = false;
      });
    fetchWithSession(
      `/api/analysis/AppOverviewKPIs?analysisid=${analysisid}&filter=${filterString}`,
    )
      .then((res) => res.json())
      .then((data) => {
        applicationlist = data;
        windowPartitionsLoading = false;
        if (!currentApp && applicationlist.length > 0) {
          currentApp = applicationlist[0].id;
        }
        loadingApp = false;
      });
  }

  function loadAppGraph(currentApp) {
    const applicableFilters = getApplicableFilters($pmfilters[analysisid]);
    const filterString = JSON.stringify(applicableFilters);
    appGraphLoading = true;
    fetchWithSession(
      `/api/analysis/getSoftwareEnvironment?analysisid=${analysisid}&napps=${napps}&stepsBefore=${levelBefore}&stepsAfter=${levelAfter}` +
        (selectedLevel === 2
          ? `&partitionlabel=` + currentApp
          : `&applicationname=` + currentApp) +
        `&filter=${filterString}`,
    )
      .then((response) => response.json())
      .then((data) => {
        graph = data;
        if (data.nodes.length === 0 && data.edges.length === 0) {
          showToast = true;
        }
        appGraphLoading = false;
        buttonsDisabled = false;
      });
  }

  function loadAppGraphTime(currentApp, napps, beforeafter) {
    const applicableFilters = getApplicableFilters($pmfilters[analysisid]);
    const filterString = JSON.stringify(applicableFilters);
    appGraphLoading = true;
    fetchWithSession(
      `/api/analysis/getSoftwareEnvironmentTime?analysisid=` +
        analysisid +
        `&beforeafter=` +
        beforeafter +
        `&napps=` +
        napps +
        `&stepsBefore=${levelBefore}&stepsAfter=${levelAfter}` +
        (selectedLevel === 2
          ? `&partitionlabel=` + currentApp
          : `&applicationname=` + currentApp) +
        (selectedLevel === 1 ? `&applogcolumn=windowtitle` : "") +
        `&filter=${filterString}`,
    )
      .then((response) => response.json())
      .then((data) => {
        graph = data;
        appGraphLoading = false;
      });
  }

  function loadAppMatrix(currentApp, napps) {
    appGraphLoading = true;
    fetchWithSession(`/api/analysis/getAppFlowMatrix?analysisid=` + analysisid)
      .then((response) => response.json())
      .then((data) => {
        getDataTable(data);
        appGraphLoading = false;
      });
  }

  function exportSWEnvironemnt() {
    const applicableFilters = getApplicableFilters($pmfilters[analysisid]);
    const filterString = JSON.stringify(applicableFilters);
    fetchWithSession(
      `/api/analysis/getSoftwareEnvironment?analysisid=${analysisid}&napps=${napps}&stepsBefore=${levelBefore}&stepsAfter=${levelAfter}` +
        (selectedLevel
          ? `&partitionlabel=` + currentApp
          : `&applicationname=` + currentApp) +
        `&filter=${filterString}&export=true`,
    )
      .then((response) => response.blob())
      .then((data) => {
        download(
          data,
          "softwareEnvironment.xlsx",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        );
      });
  }

  function getTopNgrams() {
    fetchWithSession(`/api/analysis/getTopNgrams?analysisid=` + analysisid)
      .then((response) => response.text())
      .then((data) => {
        download(data, "topngrams.csv", "text/plain");
      });
  }

  function increment(i) {
    return i + 1;
  }

  function decrement(i) {
    if (i > 1) {
      return i - 1;
    } else {
      return i;
    }
  }
</script>

<FilterToast bind:showToast />

<Breakpoint on:change={(e) => (screenSize = e.detail.breakpointValue)} />

<Header section="Workflow Analysis" breadcrumb="App Flow">
  <Button
    text="Get top Ngrams"
    on:click={getTopNgrams}
    iconLeft={true}
    icon={ARROW_LEFT_ICON}
    kind="secondary"
  />
  <Button
    text="Export to Excel"
    on:click={exportSWEnvironemnt}
    iconLeft={true}
    icon={ARROW_LEFT_ICON}
    kind="secondary"
  />
  <ContentSwitcher
    bind:selected={selectMode}
    options={["Graph", "Table"]}
    fitContent={true}
    disabled={disableModes}
  ></ContentSwitcher>
  <Filter />
</Header>

<SectionWrapper {fullscreen} fitScreen={true}>
  <div slot="main" class="main_wapper">
    {#if selectMode === 0}
      <div class="menu_overlay">
        <div class="buttons_wrapper">
          <OverflowMenu style="width: auto;">
            <div slot="menu">
              <Button
                icon={selectedLevel === 0
                  ? APPLICATIONS_ICON
                  : selectedLevel === 1
                    ? APPOVERVIEW_ICON
                    : WINDOWS_ICON}
              />
            </div>
            <OverflowMenuItem
              text="Applications"
              on:click={() => {
                selectedLevel = 0;
                currentApp = applicationlist[0].id;
              }}
              primaryFocus={selectedLevel === 0}
            />
            <OverflowMenuItem
              text="App Overview"
              on:click={() => {
                selectedLevel = 1;
                currentApp = applicationlist[0].id;
              }}
              primaryFocus={selectedLevel === 1}
            />
            <OverflowMenuItem
              text="Windows"
              on:click={() => {
                selectedLevel = 2;
                currentApp = windowlist[0].id;
              }}
              primaryFocus={selectedLevel === 2}
            />
          </OverflowMenu>
          <OverflowMenu style="width: auto;">
            <div slot="menu">
              <Button
                icon={selectedKPIindex === 0
                  ? INTERACTIONS_ICON
                  : selectedKPIindex === 1
                    ? TIME_BEFORE_ICON
                    : TIME_AFTER_ICON}
              />
            </div>
            <OverflowMenuItem
              text="Interactions"
              on:click={() => (selectedKPIindex = 0)}
              primaryFocus={selectedKPIindex === 0}
            />
            <OverflowMenuItem
              text="Time Before"
              on:click={() => (selectedKPIindex = 1)}
              primaryFocus={selectedKPIindex === 1}
            />
            <OverflowMenuItem
              text="Time After"
              on:click={() => (selectedKPIindex = 2)}
              primaryFocus={selectedKPIindex === 2}
            />
          </OverflowMenu>
        </div>
      </div>
    {/if}
    <div class="canvas">
      <div class="ui_viewer_wrapper">
        {#if appGraphLoading}
          <div class="loading_wrapper">
            <Loading withOverlay={false} />
          </div>
        {:else if selectMode === 0}
          <FlowPlotterSmall
            dottedBackground
            bind:this={flowPlotterRef}
            nodes={graph["nodes"]}
            edges={graph["edges"]}
            width="100%"
            height="100%"
            formatEdges={selectedKPIindex >= 1
              ? formatTimeDelta
              : (e) => {
                  return e;
                }}
            bind:selectedNode={currentApp}
            bind:zoomLevel
          />
        {:else}
          <div class="table-container">
            <MatrixTable header={to} rows={dataNew} loading={appGraphLoading}
            ></MatrixTable>
          </div>
        {/if}
      </div>
    </div>
    <div class="menu_overlay bottom">
      <div class="buttons_wrapper">
        <ButtonPlusMinus
          defaultvalue={1}
          text={screenSize >= 1584 ? "Connections" : "C"}
          bind:value={napps}
          unit=""
          increment={(i) => increment(i)}
          decrement={(i) => decrement(i)}
          fullDisable={buttonsDisabled}
        />
        <ButtonPlusMinus
          defaultvalue={1}
          text={screenSize >= 1584 ? "Level before" : "LB"}
          bind:value={levelBefore}
          unit=""
          increment={(i) => increment(i)}
          decrement={(i) => decrement(i)}
          fullDisable={buttonsDisabled}
        />
        <ButtonPlusMinus
          defaultvalue={1}
          text={screenSize >= 1584 ? "Level after" : "LA"}
          bind:value={levelAfter}
          unit=""
          increment={(i) => increment(i)}
          decrement={(i) => decrement(i)}
          fullDisable={buttonsDisabled}
        />
      </div>
      <div class="buttons_wrapper">
        <ButtonPlusMinus
          text={screenSize >= 1584 ? "Zoom" : "Z"}
          showValue={false}
          bind:value={zoomLevel}
        />
        <Button icon={SQUARE_LANDSCAPE_ICON} on:click={handleDownload} />

        {#if fullscreen === false}
          <Button
            icon={FULLSCREEN_ICON}
            on:click={() => {
              fullscreen = true;
            }}
          />
        {:else}
          <Button
            icon={FULLSCREEN_OFF_ICON}
            on:click={() => {
              fullscreen = false;
            }}
          />
        {/if}
      </div>
    </div>
  </div>

  <div class="menu" slot="menu">
    <Accordion heading="App Selection" open={true}>
      <AppSelection
        appData={selectedLevel === 2 ? windowlist : applicationlist}
        enableDeselection={false}
        bind:currentApp
        bind:selectedLevel
        windowSelectionEnabled={false}
        loading={selectedLevel ? loading : loadingApp}
      />
    </Accordion>
    <Accordion heading="App Information" open={true}>
      <AppInformation
        appData={selectedLevel === 2 ? windowlist : applicationlist}
        currentApp={currentAppInformation}
        loading={selectedLevel ? loading : loadingApp}
      />
    </Accordion>
  </div>
</SectionWrapper>

<style>
  .main_wapper {
    position: relative;
    height: 100%;
    width: 100%;
    min-width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .menu_overlay {
    position: absolute;
    width: 100%;
    z-index: 1; /* Stellt sicher, dass das Overlay über dem Canvas liegt */
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .bottom {
    bottom: 0;
  }

  .canvas {
    height: calc(100% - 110px);
    width: 100%;
    z-index: 0; /* Platziert das Canvas hinter den Overlays */
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .buttons_wrapper {
    display: flex;
    gap: 0.5rem;
    user-select: none;
  }

  .menu {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .ui_viewer_wrapper {
    height: 100%;
    width: 100%;
  }

  .loading_wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    height: 100%;
  }

  @media screen and (max-width: 1900px) {
    .menu_overlay {
      font-size: 0.7rem;
    }
  }
  @media screen and (max-width: 1690px) {
    .menu_overlay {
      font-size: 0.6rem;
    }
  }
</style>
